<template>
  <Dropdown @change="mt_lang()" :options="langs" v-model="$store.state.lang" optionLabel="code" optionValue="code" class="menuIdioma" panelClass="menuIdiomaPanel">
    <template #value="slotProps">
      <div v-if="slotProps.value" class="flex align-items-center">
        <div class="hidden sm:block" v-html="langs.find(x => x.code == slotProps.value).desc"></div>
        <img class="ml-2 mr-2" style="height:20px" :src="langs.find(x => x.code == slotProps.value).icon" />
      </div>
    </template>
    <template #option="slotProps">
      <div class="flex align-items-center">
        <div class="hidden sm:block" v-html="slotProps.option.desc"></div>
        <img class="ml-2 mr-2" style="height:20px;" :src="slotProps.option.icon" />
      </div>
    </template>
  </Dropdown>
</template>

<script>
import Dropdown from 'primevue/dropdown';
export default {
  components: {
    Dropdown,
  },
  data() {
    return {
      langs: [
        {
          name: 'Português',
          code: 'pt',
          desc: 'PT',
          icon: require('@/assets/icons/pt.jpg')
        },
        {
          name: 'English',
          code: 'en',
          desc: 'EN',
          icon: require('@/assets/icons/en.jpg')
        },
        {
          name: 'French',
          code: 'fr',
          desc: 'FR',
          icon: require('@/assets/icons/fr.jpg')
        },
        {
          name: 'Spanish',
          code: 'es',
          desc: 'ES',
          icon: require('@/assets/icons/es.jpg')
        },
      ],
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_lang() {
      this.fc_setLang();
      this.fc_go();
    },
  },
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
</style>
